import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { visiblePitchTemplates } from '../data/pitchTemplates';

export interface FaqItem {
  question: string;
  answer: string;
}

export const useHomeFaq = (): FaqItem[] => {
  const { t } = useTranslation();

  return useMemo(() => {
    const templateNames = visiblePitchTemplates
      .slice(0, 4)
      .map((template) => t(`pitchTemplates.${template.id}.name`, { defaultValue: template.name }))
      .join(', ');

    return [
      {
        question: t('faq.whatIsSpotdove.question'),
        answer: t('faq.whatIsSpotdove.answer'),
      },
      {
        question: t('faq.isFree.question'),
        answer: t('faq.isFree.answer'),
      },
      {
        question: t('faq.templates.question'),
        answer: t('faq.templates.answer', {
          count: visiblePitchTemplates.length,
          names: templateNames,
        }),
      },
      {
        question: t('faq.aiRewrite.question'),
        answer: t('faq.aiRewrite.answer'),
      },
    ];
  }, [t]);
};
